"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault"),
    _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _uiKit = require("@devsta/ui-kit"),
    _Caption = _interopRequireDefault(require("../Caption"));

require("./_srt-captions.scss");

var PLACEHOLDER = "SRT files contain caption information, they are a text based file delivered separately to your video and can be activated at will - Best for SEO/Multi-language videos.";

function onDeleteSrt(a) {
  var b = a.onUpdate;
  return function () {
    b();
  };
}

function renderPlaceHolder() {
  return _react["default"].createElement(_uiKit.Text, {
    noMargin: !0,
    caption: !0
  }, PLACEHOLDER);
}

function SrtCaptions(a) {
  var b = a.requestedAddons,
      c = a.appliedAddons,
      d = a.addSrt,
      e = a.updateSrt,
      f = a.disabled,
      g = b.SRT_CAPTIONS,
      h = c.SRT_CAPTIONS,
      i = void 0 === h ? [] : h;
  return _react["default"].createElement(_uiKit.LabelWrapper, {
    label: "SRT Captions",
    divContainer: !0,
    extraLabelContent: !f && _react["default"].createElement(_uiKit.Button, {
      type: "TERTIARY",
      prefix: "addfat",
      onClick: d,
      disabled: f
    })
  }, _react["default"].createElement("div", {
    className: "srt-captions"
  }, Array.isArray(g) && 0 < g.length ? g.map(function (a, b) {
    var c = e(b),
        d = g.filter(function (a) {
      var b = a.value;
      return !!b;
    }).map(function (a) {
      var b = a.value;
      return b;
    }),
        h = Array.isArray(i) ? i.filter(function (a) {
      var b = a.value;
      return !!b;
    }).map(function (a) {
      var b = a.value;
      return b;
    }) : [];
    return h.forEach(function (a) {
      d.includes(a) || d.push(a);
    }), _react["default"].createElement(_Caption["default"], {
      key: "".concat(a.value),
      defaultLanguage: a,
      onChange: c,
      onDelete: onDeleteSrt({
        onUpdate: c
      }),
      selectedCaptions: d,
      disabled: f,
      type: "SRT_CAPTIONS"
    });
  }) : renderPlaceHolder()));
}

var _default = (0, _react.memo)(SrtCaptions);

exports["default"] = _default;